import React, { useEffect, useState } from 'react';
const brands = [{
  name: 'Samsung'
}, {
  name: 'Beko'
}, {
  name: 'AEG'
}, {
  name: 'Hotpoint'
}, {
  name: 'LG'
}, {
  name: 'Indesit'
}, {
  name: 'Neff'
}, {
  name: 'Bosch'
}, {
  name: 'Zanussi'
}, {
  name: 'Whirlpool'
}, {
  name: 'Miele'
}, {
  name: 'Siemens'
}, {
  name: 'Electrolux'
}, {
  name: 'Candy'
}, {
  name: 'Hoover'
}];
const BrandCarousel = () => {
  const [position, setPosition] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setPosition(prev => prev < brands.length * 150 ? prev + 1 : 0);
    }, 30);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-12 bg-mwc-lightpink" data-id="element-33">
      <div className="container mx-auto px-4" data-id="element-34">
        <div className="text-center mb-8" data-id="element-35">
          <h2 className="text-2xl font-bold text-mwc-burgundy" data-id="element-36">
            Brands We Service
          </h2>
        </div>
        <div className="overflow-hidden relative" data-id="element-37">
          <div className="flex space-x-16 items-center whitespace-nowrap" style={{
          transform: `translateX(-${position}px)`
        }} data-id="element-38">
            {/* Duplicate the brands array to create a seamless loop */}
            {[...brands, ...brands].map((brand, index) => <div key={index} className="flex-shrink-0 h-16 w-32 flex items-center justify-center" data-id="element-39">
                <span className="text-lg font-medium text-mwc-burgundy hover:text-mwc-green transition-colors duration-300" data-id="element-40">
                  {brand.name}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default BrandCarousel;